import { Component, OnInit } from "@angular/core";
import { RoutingPath } from "src/app/configs/routing-path";
import { IUser } from "src/app/core/models/user/user";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { ActivatedRoute } from "@angular/router";
import { WresponseData } from "src/app/core/models/worker/wresponse-data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-answer-page",
  templateUrl: "./answer-page.component.html",
  styleUrls: ["./answer-page.component.scss"],
})
export class AnswerPageComponent implements OnInit {
  numRadicado;
  prePage = "";
  home = "";
  workerData: WresponseData;
  body = "";
  public userloggedin: IUser = {};

  constructor(
    private _STORAGE: LocalStorageService,
    private _ROUTER: ActivatedRoute
  ) {}

  ngOnInit() {
    this.userloggedin = this._STORAGE.getItemJSON("userloggedin");
    this.numRadicado = this._ROUTER.snapshot.paramMap.get("id");
    this.home = `${RoutingPath.appRouting.components.dashboard.path}`;
    this.prePage =
      `${RoutingPath.appRouting.components.individual_retreat.path}/` +
      `${RoutingPath.appRouting.components.individual_retreat.pages.home.path}`;
    const typeReuqest = this.numRadicado.slice(0, 3);
    const informacionTrabajador = this._STORAGE.getItemJSON(
      environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION
    ).validacion_afiliado.afiliado;
    switch (typeReuqest) {
      case "AFI":
      case "CEC":
        this.body =
          "Tu solicitud ha sido procesada con éxito, y sera solucionada en tres dias hábiles";
        this.prePage = `${RoutingPath.appRouting.components.workers_information.path
        }`;
        break;
      case "RTM":
        this.prePage = `${
          RoutingPath.appRouting.components.dashboard.path +
          "/" +
          RoutingPath.appRouting.components.dashboard.pages.retreat.path
        }`;
        this.body =
          "El archivo ha sido recibido exitosamente y se encuentra en proceso de validación. La respuesta será enviada al correo registrado en el transcurso de las próximas 24 horas.";
        break;
      case "RBT":
        this.body =
          "Tu solicitud ha sido radicada con éxito y será solucionada en los tiempos establecidos";
        this.prePage = `${
          RoutingPath.appRouting.components.workers_information.path +
          "/" +
          RoutingPath.appRouting.components.workers_information.pages
            .consult_worker.path
        }`;
        break;
      case "AFD":
        this.body =
          "Tu solicitud ha sido radicada con éxito y será solucionada en tres días hábiles";
        this.prePage = `${
          RoutingPath.appRouting.components.workers_information.path +
          "/" +
          RoutingPath.appRouting.components.workers_information.pages
            .consult_worker.path
        }`;
        break;
      case "RIT":
        this.prePage =
          `${RoutingPath.appRouting.components.individual_retreat.path}/` +
          `${RoutingPath.appRouting.components.individual_retreat.pages.home.path}`;
        this.body =
          "Tu solicitud ha sido procesada con éxito, para validar el retiro te invitamos a descargar el certificado del trabajador en 24 horas";
        break;
      case "ACM":
        this.prePage = `${
          RoutingPath.appRouting.components.workers_information.path +
          "/" +
          RoutingPath.appRouting.components.workers_information.pages
            .query_result.path +
          "/" +
          informacionTrabajador.tipoDocumento +
          "/" +
          informacionTrabajador.numeroDocumento
        }`;
        this.body =
          "Tu solicitud ha sido radicada con éxito y será solucionada en tres días hábiles";
        break;

      default:
        break;
    }
  }
}
